import ReactGA from 'react-ga';

// eslint-disable-next-line
console.log('Initializing Analytics');

ReactGA.initialize('UA-127451916-1');
